import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"breakpoints":{"xs":767,"sm":991,"md":1199,"ld":1440,"lg":1800,"xlg":Infinity}})
